import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "currentColor",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M10.65 3.704c.8-.6 1.9-.6 2.7 0l6.5 4.875c.566.425.9 1.091.9 1.8v8.12a2.25 2.25 0 0 1-2.25 2.25h-13a2.25 2.25 0 0 1-2.25-2.25v-8.12c0-.709.334-1.375.9-1.8zm1.8 1.2a.75.75 0 0 0-.9 0l-6.5 4.875a.75.75 0 0 0-.3.6v8.12c0 .415.336.75.75.75h5.75v-3a.75.75 0 0 1 1.5 0v3h5.75a.75.75 0 0 0 .75-.75v-8.12a.75.75 0 0 0-.3-.6z" }, null, -1)
  ]))]))
}
export default { render: render }